import { render } from "./JobStackDeploymentDetailsEdit.vue?vue&type=template&id=c90588fa&scoped=true"
import script from "./JobStackDeploymentDetailsEdit.vue?vue&type=script&lang=js"
export * from "./JobStackDeploymentDetailsEdit.vue?vue&type=script&lang=js"

import "./JobStackDeploymentDetailsEdit.vue?vue&type=style&index=0&id=c90588fa&scoped=true&lang=css"
import "./JobStackDeploymentDetailsEdit.vue?vue&type=style&index=1&id=c90588fa&lang=scss&scoped=true"

import exportComponent from "/Users/sivasankarelango/Sivasankar/test-cx/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c90588fa"]])

export default __exports__